import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Check, Zap, Loader2, X } from "lucide-react";

export const UpgradeNudge = () => {
  const [nudge, setNudge] = useState(null);
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const handler = (e) => setNudge(e.detail);
    window.addEventListener("tr-upgrade-required", handler);
    return () => window.removeEventListener("tr-upgrade-required", handler);
  }, []);

  useEffect(() => {
    if (!nudge) return;
    api.get("/subscriptions/plans")
      .then(r => setPlan((r.data || []).find(p => p.key === nudge.needed_plan) || null))
      .catch(() => setPlan(null));
  }, [nudge]);

  if (!nudge) return null;

  const checkout = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/subscriptions/checkout", {
        plan_key: nudge.needed_plan, origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch {
      setBusy(false);
      window.location.href = "/billing";
    }
  };

  return (
    <div className="fixed inset-0 z-[85] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" data-testid="upgrade-nudge-modal">
      <div className="bg-[#0a0e1a] border border-cyan-400/25 rounded-2xl max-w-md w-full p-6 shadow-2xl relative">
        <button onClick={() => setNudge(null)} data-testid="upgrade-nudge-close"
          className="absolute top-4 right-4 text-slate-500 hover:text-white"><X className="w-4 h-4" /></button>
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-400/20 to-cyan-400/10 border border-amber-400/30 flex items-center justify-center mb-4">
          <Zap className="w-5 h-5 text-amber-300" />
        </div>
        <h3 className="font-display text-xl font-bold text-white">Unlock this with {nudge.needed_plan_name}</h3>
        <p className="text-sm text-slate-400 mt-2 leading-relaxed" data-testid="upgrade-nudge-message">{nudge.message}</p>
        {plan && (
          <div className="mt-4 rounded-lg border border-cyan-400/25 bg-cyan-400/5 p-4">
            <div className="flex items-baseline justify-between">
              <span className="font-display font-bold text-white">{plan.name}</span>
              <span><span className="font-display text-2xl font-bold brand-gradient">{plan.price_label || `$${Math.round(plan.price_monthly).toLocaleString()}`}</span><span className="text-slate-400 text-xs">/mo</span></span>
            </div>
            <ul className="mt-3 space-y-1.5">
              {(plan.features || []).slice(0, 4).map((f, i) => (
                <li key={i} className="text-xs text-slate-300 flex gap-2"><Check className="w-3.5 h-3.5 text-cyan-300 shrink-0 mt-px" /> {f}</li>
              ))}
            </ul>
          </div>
        )}
        <div className="mt-5 flex gap-2">
          <button onClick={() => setNudge(null)} data-testid="upgrade-nudge-later"
            className="px-4 py-2.5 rounded-full border border-white/10 text-slate-300 text-sm hover:border-white/25 transition-colors">
            Maybe later
          </button>
          <button onClick={checkout} disabled={busy} data-testid="upgrade-nudge-checkout-btn"
            className="flex-1 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-900 font-semibold text-sm px-5 py-2.5 hover:opacity-90 disabled:opacity-50 inline-flex items-center justify-center gap-2">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            Upgrade now{plan ? ` — $${Math.round(plan.price_monthly).toLocaleString()}/mo` : ""}
          </button>
        </div>
      </div>
    </div>
  );
};
